import { defineStore } from 'pinia';
import { ref } from 'vue';

import { getAdminInfo, userLogin } from '@/api/login';
import { usePermissionStore } from '@/store';

// import type { UserInfo } from '@/types/interface';

const InitUserInfo = ref({
  name: '', // 用户名，用于展示在页面右上角头像处
  roles: [],
  permissions: [],
});

const normalizePermissions = (permissions: unknown) => {
  if (!Array.isArray(permissions)) return [];
  return [...new Set(permissions.filter(Boolean))];
};

export const useUserStore = defineStore('user', {
  state: () => ({
    token: '', // 默认token不走权限
    userInfo: { ...InitUserInfo.value },
  }),
  getters: {
    roles: (state) => {
      return state.userInfo?.permissions || state.userInfo?.roles || [];
    },
  },
  actions: {
    async login(loginForm: Record<string, unknown>) {
      const { data } = await userLogin(loginForm);
      // 登录成功后处理
      this.token = data.token;
      this.userInfo = {
        ...this.userInfo,
        ...data.userInfo,
        permissions: normalizePermissions(data.userInfo?.permissions || []),
      };
      await this.getUserInfo();
    },

    async getUserInfo() {
      const { data } = await getAdminInfo();
      this.userInfo = {
        ...this.userInfo,
        ...data,
        permissions: normalizePermissions(data.permissions || []),
      };
      const permissionStore = usePermissionStore();
      await permissionStore.initRoutes(this.userInfo.permissions);
    },

    async logout() {
      try {
        // await userLogout();
      } catch (e) {
        console.log(e);
      } finally {
        this.token = '';
        this.userInfo = { ...InitUserInfo.value };
      }
    },
  },
  persist: {
    afterRestore: () => {
      const permissionStore = usePermissionStore();
      permissionStore.restore();
    },
    key: 'jjyCloud_next',
    paths: ['token', 'userInfo', 'accountList'],
  },
});
